import React, { createContext, useContext, useMemo } from 'react';
import { bindScopedEndpoints, type SessionEndpoints } from './endpointManifest';
import type { OrganizationId } from './identity';

const SessionEndpointsReactContext = createContext<SessionEndpoints | null>(null);

export const SessionEndpointsProvider = ({ children, organization }: { children: React.ReactNode; organization: OrganizationId | null }) => {
  const endpoints = useMemo(() => (organization === null ? null : bindScopedEndpoints(organization)), [organization]);
  return <SessionEndpointsReactContext.Provider value={endpoints}>{children}</SessionEndpointsReactContext.Provider>;
};

export const useSessionEndpoints = (): SessionEndpoints => {
  const endpoints = useContext(SessionEndpointsReactContext);
  if (endpoints === null) {
    throw new Error('useEndpoints must be used inside OrganizationScope on an organization route');
  }
  return endpoints;
};
